// Convert lat/lon (degrees) to 3D position on a sphere
export function latLonToVector3(lat, lon, radius = 1) {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lon + 180) * (Math.PI / 180);
  
  const x = -(radius * Math.sin(phi) * Math.cos(theta));
  const y = radius * Math.cos(phi);
  const z = radius * Math.sin(phi) * Math.sin(theta);
  
  return [x, y, z];
}

// Get a point elevated above the sphere for arc curves
export function getArcMidpoint(startLat, startLon, endLat, endLon, radius = 1, elevation = 0.3) {
  const midLat = (startLat + endLat) / 2;
  const midLon = (startLon + endLon) / 2;
  
  // Calculate distance for elevation scaling
  const dLat = Math.abs(endLat - startLat);
  const dLon = Math.abs(endLon - startLon);
  const dist = Math.sqrt(dLat * dLat + dLon * dLon);
  const arcElevation = elevation * (1 + dist / 180);
  
  return latLonToVector3(midLat, midLon, radius + arcElevation);
}

// Generate arc points between two coordinates
export function generateArcPoints(startLat, startLon, endLat, endLon, radius = 1, segments = 50, elevation = 0.25) {
  const points = [];
  const start = latLonToVector3(startLat, startLon, radius);
  const end = latLonToVector3(endLat, endLon, radius);
  const mid = getArcMidpoint(startLat, startLon, endLat, endLon, radius, elevation);
  
  for (let i = 0; i <= segments; i++) {
    const t = i / segments;
    const t2 = t * t;
    const mt = 1 - t;
    const mt2 = mt * mt;
    
    // Quadratic bezier
    const x = mt2 * start[0] + 2 * mt * t * mid[0] + t2 * end[0];
    const y = mt2 * start[1] + 2 * mt * t * mid[1] + t2 * end[1];
    const z = mt2 * start[2] + 2 * mt * t * mid[2] + t2 * end[2];
    
    points.push([x, y, z]);
  }
  
  return points;
}

// Get country flag emoji from country code
export function getCountryFlag(countryCode) {
  if (!countryCode) return '\uD83C\uDF10'; // Globe
  
  // Special codes for private networks
  if (countryCode === 'LN' || countryCode === 'LH' || countryCode === 'IN' || countryCode === 'PR') {
    return '🏠'; // House for local network
  }
  
  if (countryCode === 'XX') return '\uD83C\uDF10'; // Globe for unknown
  
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

// Status to color mapping
export function getStatusColor(status) {
  switch (status) {
    case 'normal': return '#00ff9d';
    case 'warning': return '#fbbf24';
    case 'threat': return '#ff3b3b';
    default: return '#00ff9d';
  }
}

export function getStatusLabel(status) {
  switch (status) {
    case 'normal': return 'OK';
    case 'warning': return 'LATENCY';
    case 'threat': return 'THREAT';
    default: return 'OK';
  }
}
